<template>
    <div class="tabcontent">
        <v-row justify="space-between">
            <v-col cols="12" md="8" sm="12">
                <v-form ref="form" v-model="valid">
                    <div>
                        <v-row >
                          <v-col cols="12" md="4">
                            <v-subheader>Организация</v-subheader>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-skeleton-loader
                                :loading="loading"
                                type="list-item"
                                class="mx-auto"
                            >
                              <v-select
                                  v-model="IdTsj"
                                  :items="orglist"
                                  @input="refreshHandler"
                              ></v-select>
                            </v-skeleton-loader>
                          </v-col>
                        </v-row>
                        <v-row >
                          <v-col cols="12" md="4">
                            <v-subheader>Вид</v-subheader>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-skeleton-loader
                                :loading="loading"
                                type="list-item"
                                class="mx-auto"
                            >
                              <v-select
                                  v-model="type"
                                  :items="typeszayav"
                                  :dense="true"
                                  @input="refreshHandler"
                              ></v-select>
                            </v-skeleton-loader>
                          </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="8" offset="4">
                                <v-skeleton-loader
                                        :loading="loading"
                                        type="list-item"
                                        class="mx-auto"
                                >
                                    <v-radio-group v-model="IsPodstatia" :column="false">
                                        <v-radio
                                                :key="0"
                                                label="Группа"
                                                :value="0"
                                        ></v-radio>
                                        <v-radio
                                                :key="1"
                                                label="Статья"
                                                :value="1"
                                                class="ml-2"
                                        ></v-radio>
                                        <v-radio
                                                :key="2"
                                                label="Подстатья"
                                                :value="2"
                                                class="ml-2"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-skeleton-loader>
                            </v-col>
                        </v-row>
                        <v-row v-show="IsPodstatia > 0">
                            <v-col cols="12" md="4">
                                <v-subheader>Группа</v-subheader>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-skeleton-loader
                                        :loading="loading"
                                        type="list-item"
                                        class="mx-auto"
                                >
                                    <v-combobox
                                            v-model="group"
                                            :items="groupszayav"
                                            :dense="true"
                                    ></v-combobox>
                                </v-skeleton-loader>
                            </v-col>
                        </v-row>
                        <v-row v-show="IsPodstatia > 1">
                            <v-col cols="12" md="4">
                                <v-subheader>Cтатья для подстатьи</v-subheader>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-combobox
                                        v-model="rootst"
                                        :items="rootstatilist"
                                        :dense="true"
                                ></v-combobox>
                            </v-col>
                        </v-row>
                      <!--v-show="IsPodstatia < 1"-->

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-subheader>Наименование</v-subheader>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-skeleton-loader
                                        :loading="loading"
                                        type="list-item"
                                        class="mx-auto"
                                >
                                    <v-text-field
                                            v-model="name"
                                            :counter="1000"
                                            :rules="nameRules"
                                            :dense="true"
                                    ></v-text-field>
                                </v-skeleton-loader>
                            </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-subheader>Номер</v-subheader>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-skeleton-loader
                                :loading="loading"
                                type="list-item"
                                class="mx-auto"
                            >
                              <v-text-field
                                  v-model="Numb"
                                  :rules="NumbRules"
                                  :dense="true"
                              ></v-text-field>
                            </v-skeleton-loader>
                          </v-col>
                        </v-row>
                        <!--
                        <v-row v-if="type==1">
                          <v-col cols="12" md="4">
                            <v-subheader>Процент рентабельности</v-subheader>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-skeleton-loader
                                :loading="loading"
                                type="list-item"
                                class="mx-auto"
                            >
                              <v-text-field
                                  v-model="percent"
                                  :dense="true"
                                  :rules="[numberRule]"
                              ></v-text-field>
                            </v-skeleton-loader>
                          </v-col>
                        </v-row>
                        !-->
                        <v-row v-if="type==0 && IsPodstatia>0">
                          <v-col cols="12" md="4">
                            <v-subheader>Вид услуги</v-subheader>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-skeleton-loader
                                :loading="loading"
                                type="list-item"
                                class="mx-auto"
                            >
                              <v-select
                                  v-model="TypeYslugi"
                                  :items="TypeYslugiItem"
                                  :dense="true"
                              ></v-select>
                            </v-skeleton-loader>
                          </v-col>
                        </v-row>
                        <v-row v-if="type==0 && IsPodstatia>0">
                          <v-col cols="12" md="4">
                            <v-subheader>Тип услуги</v-subheader>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-skeleton-loader
                                :loading="loading"
                                type="list-item"
                                class="mx-auto"
                            >
                              <v-select
                                  v-model="TypePost"
                                  :items="TypePostItem"
                                  :dense="true"
                              ></v-select>
                            </v-skeleton-loader>
                          </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="8" offset="4">
                                <v-skeleton-loader
                                        :loading="loading"
                                        type="list-item"
                                        class="mx-auto"
                                >
                                  <v-checkbox v-model="isVolume" label="Есть объем" ></v-checkbox>
                                </v-skeleton-loader>
                            </v-col>
                        </v-row>
                    </div>
                    <input type="hidden" v-model="id">
                    <v-row>
                        <v-col cols="12" md="4"></v-col>
                        <v-col cols="12" md="8">
                            <v-btn color="primary" class="mr-4" @click="saveStatii">
                                Сохранить
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <v-snackbar
                v-model="snackbarresult"
                :timeout="resulttimeout"
        >
            {{ resulttext }}
        </v-snackbar>
    </div>
</template>

<script>

    import { bus } from '../../plugins/bus.js'

    export default {
        name: "StatiiZatratAdd",
        props: ['id', 'idx', 'Type', 'IdOrg'],
        mounted() {
          this.$store.dispatch('GET_ORG_LIST', {});
          this.$store.dispatch('GET_TYPE_STATII');

          /*this.$store.dispatch('GET_STATIILIST', {IdOrg: this.IdTsj, Type: this.type}).then(() => {
            this.loadData();
          });*/
          /*this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdTsj ? this.IdTsg : 0, IdHouse: this.IdHouse ? this.IdHouse : -1}).then(() => {
              this.loadData();
          });*/

          this.loadData();
          bus.$on('refreshTabStatiiZatratAdd'+this.$props.id, this.refreshHandler);
        },
        data() {
            return {
                loading: true,
                Numb: '',
                name: '',
                valid: true,
                type: 0,
                typeszayav: [
                    {value: 0, text: 'Поступления'},
                    {value: 1, text: 'Расходы'}
                ],

                group: null,
                rootst: null,
                IsPodstatia: 0,
                nameRules: [
                    v => !!v || 'Введите Наименование',
                    v => (v && v.length <= 1000) || 'Наименование не более 1000 символов',
                ],
               NumbRules: [
                  v => !!v || 'Введите Номер',
                ],
                snackbarresult: false,
                resulttimeout: 2000,
                isVolume: false,
                resulttext: '',
                IdTsj:localStorage.getItem('idtsg'),
                percent: 0,
                TypeYslugi: 0,
                TypePost: 0,

            }
        },

        computed: {
            groupszayav() {
                let groups = this.$store.getters.STATIILIST ? this.$store.getters.STATIILIST.data : null;
                // let ret = [{value: 0, text: ''}];
                let ret = [];
                if (groups) {
                    // eslint-disable-next-line no-unused-vars
                    Object.entries(groups).forEach(([key, group]) => {
                        if (group.ID) {
                            let Numb = '';
                            if(group.Numb>0)
                              Numb = group.Numb;

                            ret.push({value: group.ID, text: Numb +' '+group.Name, Type: group.Type});
                        }
                    });
                }
                return ret;
            },
            rootstatilist() {
                let statilist = this.$store.getters.STATIILIST ? this.$store.getters.STATIILIST.data : null;
                let ret = [];
                if (statilist) {
                    // eslint-disable-next-line no-unused-vars
                    Object.entries(statilist).forEach(([key, item]) => {
                        //if (this.group) console.log(item.ID+" == "+this.group.value);
                        if (this.group && item.ID == this.group.value) {
                            let NumbOne = '';
                            if (item.Name) {
                                if(item.Numb>0)
                                  NumbOne = item.Numb;
                                ret.push({header: NumbOne+' '+item.Name});
                            }
                            item.sub.forEach((itemst) => {
                                if (this.id == 0 || (this.id > 0 && this.id != itemst.ID)){
                                  let Numb = '';
                                  if(itemst.Numb>0)
                                    Numb = NumbOne+'.'+itemst.Numb;

                                  ret.push({text: Numb+' '+itemst.Name, value: itemst.ID, Root: itemst.Root, Type: itemst.Type});
                                }

                            });
                        }
                    });
                }
                return ret;
            },
            orglist() {
              let ret = [];
              if (this.$store.getters.ORG) {
                /*if(localStorage.getItem('idtsg')>0){
                  this.$store.getters.ORG.orglist.forEach((item) => {
                    if(item.ID == localStorage.getItem('idtsg'))
                      ret.push({text: item.Name, value: item.ID});
                  });
                }else{*/
                if(localStorage.getItem('idtsg')>0){
                  this.$store.getters.ORG.orglist.forEach((item) => {
                    if(item.ID == localStorage.getItem('idtsg'))
                      ret.push({text: item.Name, value: item.ID});
                  });
                }else{
                  this.$store.getters.ORG.orglist.forEach((item) => {
                    ret.push({text: item.Name, value: item.ID});
                  });
                }

              }
              return ret;
            },
            TypeYslugiItem(){
              let ret = [];
              if (this.$store.getters.TYPE_STATII) {
                this.$store.getters.TYPE_STATII.TypeUsl.forEach((item,index) => {
                  ret.push({value: index, text:item });
                });
              }
              return ret;
            },
            TypePostItem(){
              let ret = [];
              let typePost = [];
              if (this.$store.getters.TYPE_STATII) {
                if (parseInt(this.TypeYslugi)>=0) {
                  typePost = this.$store.getters.TYPE_STATII.TypePost[this.TypeYslugi];
                  Object.entries(typePost).forEach((item) => {
                    ret.push({value: parseInt(item[0]), text: item[1]});
                  });
                }
              }
              return ret;
            },
        },
        methods: {
            numberRule: v  => {
              if (!isNaN(parseFloat(v)) && v >= 0 && v <= 100) return true;
              return 'Введите процент от 0 до 100';
            },
            formatCurrency(value) {
                let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
                return formatter.format(value/1);
            },
            fromCurrency(value) {
                value = value.replace(/\s/, '');
                value = value.replace(/,/, '.');
                return value;
            },
            /*changeGroup(group) {
              this.type = group.Type;
            },*/
            loadData() {
                if (this.$props.id > 0) {
                    this.$store.dispatch('EDIT_STATIILIST', {id: this.$props.id})
                        .then(response => {
                          this.$store.dispatch('GET_STATIILIST', {IdOrg: response.data.IdTsj, Type: response.data.Type}).then(() => {

                            this.group = this.rootst = {value: 0, text: ''};
                            this.IsPodstatia = parseInt(response.data.Layer);
                            if (this.IsPodstatia == 2) {
                                const statilist = this.$store.getters.STATIILIST ? this.$store.getters.STATIILIST.data : null;
                                let find = false;
                                if (statilist) {
                                    for (let itemgr of statilist) {
                                        for (let item of itemgr.sub) {
                                            for (let itemsub of item.sub) {
                                                if (itemsub.ID == response.data.ID) {
                                                    this.group = {text: itemgr.Name, value: itemgr.ID, Root: itemgr.Root, Type: itemgr.Type};
                                                    this.rootst = {text: item.Name, value: item.ID, Root: item.Root, Type: itemgr.Type};
                                                    find = true;
                                                    break;
                                                }
                                            }
                                            if (find) break;
                                        }
                                        if (find) break;
                                    }
                                }
                            } else if (this.IsPodstatia == 1) {
                                for(let item of this.groupszayav) {
                                    if (item.value == response.data.Root) {
                                        this.group = item;
                                    }
                                }
                            }
                            this.name = response.data.Name;
                            this.Numb = response.data.Numb;
                            this.type = parseInt(response.data.Type);
                            if(parseInt(response.data.isVolume)>0){
                                this.isVolume = true;
                            }else{
                                this.isVolume = false;
                            }
                            this.percent = response.data.percentProfit;
                            this.IdTsj = response.data.IdTsj;
                            this.TypeYslugi = parseInt(response.data.TypeYslugi);
                            this.TypePost = parseInt(response.data.TypePost);
                            this.loading = false;
                          });
                        });
                } else {
                    //this.$refs.form.reset();
                    this.$store.dispatch('GET_STATIILIST', {IdOrg: this.IdTsj, Type: this.type});
                    this.loading = false;
                }
            },
            saveStatii () {
                if (this.Numb === '' ||this.name === '' || (this.IsPodstatia == 1 && !this.group) || (this.IsPodstatia == 2 && !this.rootst) || !this.IdTsj>0) {
                    return;
                }
                let isVolume;
                if(this.isVolume)
                    isVolume = 1;
                else
                    isVolume = 0;

                let res;
                if (this.$props.id > 0) {
                    res = this.$store.dispatch('UPDATE_STATIILIST', {
                        ID: this.id,
                        IdTsj: this.IdTsj,
                        Name: this.name,
                        Numb: this.Numb,
                        Type: this.type,
                        Layer: this.IsPodstatia,
                        isVolume: isVolume,
                        percentProfit: this.percent,
                        TypeYslugi: this.TypeYslugi,
                        TypePost: this.TypePost,
                        Root: this.IsPodstatia == 2 ? this.rootst.value : (this.IsPodstatia == 1 ? this.group.value : 0),
                    });
                } else {
                    res = this.$store.dispatch('SAVE_STATIILIST', {
                        IdTsj: this.IdTsj,
                        Name: this.name,
                        Numb: this.Numb,
                        Type: this.type,
                        Layer: this.IsPodstatia,
                        isVolume: isVolume,
                        percentProfit: this.percent,
                        TypeYslugi: this.TypeYslugi,
                        TypePost: this.TypePost,
                        Root: this.IsPodstatia == 2 ? this.rootst.value : (this.IsPodstatia == 1 ? this.group.value : 0),
                    });
                }
                res.then(response => {
                    //console.log(this.$vnode.key);
                    if (response.status === 1) {
                        this.$parent.closeTab(this.$vnode.key, 'tabStatiiZatrat0');
                        bus.$emit('refreshTabStatiiZatrat', {});
                    } else {
                        this.resulttext = response.message;
                        this.snackbarresult = true;
                    }
                });
            },

            refreshHandler() {
                this.loadData();
            }
        }
    }
</script>

<style scoped>
    .tabcontent {
        padding-top: 45px;
    }
</style>